import { Button } from "@mui/material";

const DownloadTemplateButton = ({ onClick, disabled }) => {
  return (
    <Button
      variant={disabled ? "contained" : "outlined"}
      color={disabled ? "primary" : "inherit"}
      sx={{
        pr: 1.5,
        pl: 1,
        py: 0,
        lineHeight: "35px",
        borderRadius: "20px",
      }}
      startIcon={<img src={`assets/buttons/download${disabled ? "-disabled" : ""}.svg`} alt="Download Template" />}
      onClick={onClick}
      disabled={disabled}
    >
      Download Template
    </Button>
  );
};

export default DownloadTemplateButton;
